module.exports = __webpack_public_path__ + "static/img/dongtu.f9bd749b.gif";